import { useURLFilters } from '~/screens/MyAgency/hooks/useURLFilters';
import { useMyAgencyStore } from '~/screens/MyAgency/store/useMyAgencyStore';
import { FilterMap, Filters, Platform } from '~/screens/MyAgency/types';

import { PLATFORM_OPTIONS } from '../components/PlatformsToggle';

export type AdvancedFilters = {
  /** This returns an array of applied filters */
  appliedFilters: Filters[];
  /** This sets a new filter value */
  setFilter: <P extends Platform, K extends keyof FilterMap[P]>(
    platform: P,
    filterType: K,
    value: FilterMap[P][K],
  ) => void;
  /** This gets the value of an applied filter */
  getFilter: <P extends Platform, K extends keyof FilterMap[P]>(
    platform: P,
    filterType: K,
  ) => FilterMap[P][K] | undefined;
  /** This clears one or more filters */
  clearFilters: (
    platform?: Platform,
    filterTypes?: (keyof FilterMap[Platform])[],
  ) => void;
  /** The active platform */
  activePlatform: Platform;
  // @platfom-type-issue making a tag so I can fix this wrong typing later
  // activePlatform: Platform | PLATFORM_OPTIONS.selectPlatform;
  /** Set the active platform */
  setActivePlatform: (platform: Platform | null) => void;
  /** Drawer state */
  isDrawerOpen: boolean;
  /** Set the drawer state */
  setIsDrawerOpen: (isOpen: boolean) => void;
};

// Custom hook for managing advanced filters
export const useAdvancedFiltersStore = (
  {
    clearPlatform,
  }: {
    clearPlatform?: boolean;
  } = {
    clearPlatform: true,
  },
): AdvancedFilters => {
  const {
    isAdvancedFiltersDrawerOpen: isDrawerOpen,
    setIsAdvancedFiltersDrawerOpen: setIsDrawerOpen,
  } = useMyAgencyStore();

  const {
    appliedFilters,
    getFilter,
    setFilter,
    clearFilters: clearUrlFilters,
    activePlatformUrl,
    setActivePlatformUrl,
  } = useURLFilters();

  const clearFiltersAndResetPlatform = (
    platform?: Platform,
    filterTypes?: (keyof FilterMap[Platform])[],
  ) => {
    const isLastFilter = appliedFilters.length === 1;
    clearUrlFilters(platform, filterTypes);

    if (clearPlatform || isLastFilter) {
      setActivePlatformUrl(null);
    }
  };

  return {
    getFilter,
    setFilter,
    clearFilters: clearFiltersAndResetPlatform,
    appliedFilters,
    activePlatform: activePlatformUrl || PLATFORM_OPTIONS.selectPlatform,
    setActivePlatform: setActivePlatformUrl,
    isDrawerOpen,
    setIsDrawerOpen,
  };
};
